import styled from 'styled-components'

export const ContainerButtons = styled.div`
  height: 2.25rem;
`

ContainerButtons.displayName = 'ContainerButtons'

export const Content = styled.div`
  overflow-x: auto;

  ::-webkit-scrollbar {
    height: 0.4rem;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
    height: var(--spacer-2);
    width: var(--spacer-2);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--gray-300);
    border-radius: var(--border-radius-sm);
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--gray-400);
  }
`

Content.displayName = 'Content'
